import React from 'react';
import logo from './logo-collapsed.svg';
import './MobileSidebarLogo.css';
import { useIwaContext } from '@cognitranlimited/itis-web';
export var MobileSidebarLogo = function () {
    var strings = useIwaContext().strings;
    return React.createElement("img", { className: "MobileSidebarLogo", src: logo, alt: strings.app.name });
};
